<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Request A New Model" | translate | async }}<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">
    <div>
      <mat-form-field class="require-model-input">
        <input class="email-from" matInput placeholder="{{'Email' | translate | async}}" type="text" [(ngModel)]="email"
          [formControl]="emailControl" ngDefaultControl required>
      </mat-form-field>
      <div *ngIf="emailControl.errors && (emailControl.dirty || emailControl.touched)" style="margin-bottom: 20px;">
        <mat-error *ngIf="emailControl.errors.required">{{'Email is required'| translate | async}}</mat-error>
        <mat-error *ngIf="emailControl.errors.email">{{'Email is invaild'| translate | async}}</mat-error>
      </div>
    </div>
    <div>
      <mat-form-field class="require-model-input">
        <input class="email-from" matInput placeholder="{{'Model Required' | translate | async}}" type="text"
          [(ngModel)]="model" [formControl]="modelControl" ngDefaultControl required>
      </mat-form-field>
      <div *ngIf="modelControl.errors && (modelControl.dirty || modelControl.touched)" style="margin-bottom: 20px;">
        <mat-error *ngIf="modelControl.errors.required">{{'A Model is required'| translate | async}}</mat-error>
      </div>
    </div>
    <div>
      <mat-form-field class="require-model-input">
        <input class="email-from" matInput placeholder="{{'Make Required' | translate | async}}" type="text"
          [(ngModel)]="make" [formControl]="makeControl" ngDefaultControl required>
      </mat-form-field>
      <div *ngIf="makeControl.errors && (makeControl.dirty || makeControl.touched)" style="margin-bottom: 20px;">
        <mat-error *ngIf="makeControl.errors.required">{{'A Make is required'| translate | async}}</mat-error>
      </div>
    </div>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">{{'Cancel' | translate | async}}</button>
    <button mat-raised-button color="warn" [disabled]="modelControl.errors || emailControl.errors ||makeControl.errors"
      [class.loading]="saving" (click)="save()">
      <span class="material-icons button__icon">check</span><span class="button__text">{{'Send' | translate |
        async}}</span>
    </button>
  </div>
</div>